import { render } from "./UserManager.vue?vue&type=template&id=6faadd1e&scoped=true"
import script from "./UserManager.vue?vue&type=script&lang=js"
export * from "./UserManager.vue?vue&type=script&lang=js"

import "./UserManager.vue?vue&type=style&index=0&id=6faadd1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faadd1e"]])

export default __exports__